



























import { Component, Vue, Prop } from 'vue-property-decorator'
import { Arg, EnumType, Field, FieldType } from '@/types/graphql'
import FieldName from '@/components/graphql/shared/FieldName.vue'
import { routeTo } from '@/lib/routeBuilder'

@Component({ components: { FieldName } })
export default class TypeTooltip extends Vue {
  @Prop({ required: true }) target!: string
  @Prop({ required: true }) fieldType!: FieldType

  private uuids = {}

  get enums (): EnumType[] | null {
    return this.unwrapped.enums?.length ? this.unwrapped.enums : null
  }

  get hasContent (): boolean {
    return !!this.unwrapped.description?.length || !!this.unwrapped.args?.length ||
      !!this.unwrapped.enums?.length
  }

  get isInput (): boolean {
    return this.unwrapped.name === 'input'
  }

  get unwrapped () {
    if (this.fieldType.name === 'collection') return (this.fieldType.value as FieldType)
    return this.fieldType
  }

  routeTo (item: Field | Arg) {
    return routeTo(this.$route.params.api, item)
  }
}
